<template>
    <table class="table table-success table-striped table-hover">
        <thead>
            <tr style="font-size: 12px;"><!-- class="text-uppercase" -->
                <th scope="col" v-for="titulo, key in titulos" :key="key">{{ titulo.titulo }}
                </th>
                <th v-if="editar || remover || rateio"></th>
            </tr>
        </thead>
        <tbody style="font-size: 12px;">
            <tr v-for="obj, chave in dadosFiltrados" :key="chave">
                <td v-for="valor, chaveValor in obj" :key="chaveValor">
                    <div v-if="titulos[chaveValor].titulo == 'Aprovação'"
                        :class="obj.aprovacao == 'sim' ? 'carimbo' : ''"></div>
                    <div v-if="titulos[chaveValor].titulo == 'Status'" :class="obj.status"></div>
                    <span v-if="titulos[chaveValor].tipo == 'texto'">{{ valor }}</span>
                    <span v-if="titulos[chaveValor].tipo == 'data'">{{ valor | formataDataGlobal }}</span>
                    <span v-if="titulos[chaveValor].tipo == 'dataCx'">{{ valor | formataDataCxGlobal }}</span>
                    <span v-if="titulos[chaveValor].titulo == 'Caps Paciente'">{{ valor.nome }}</span>
                    <span v-if="titulos[chaveValor].titulo == 'Caps Lancamento'">{{ valor.nome }}</span>
                </td>
                <td>
                    <div style="display: flex; justify-content: end;">
                        <button v-if="editar" class="btn btn-outline-primary btn-sm float-end"
                            style="margin-right: 5px;" :data-bs-toggle="editar.dataToggle"
                            :data-bs-target="editar.dataTarget" :id="'lan_rateio' + obj.id"
                            @click="setStore(obj)">Editar</button> 
                        <a v-if="pdf && obj.status == 'finalizado'"
                            :href="'https://contasmoradores.candido.org.br/pdf-' + pdf.url + '/' + obj.caps.id + '/' + obj.id"
                            target="_blank" class="btn btn-outline-danger float-end"
                            style="font-size: 11px; margin-right: 5px;">PDF</a>
                        <button v-if="remover && obj.status == 'criacao'" class="btn btn-outline-danger btn-sm float-end"
                            style="margin-right: 5px;" :data-bs-toggle="remover.dataToggle"
                            :data-bs-target="remover.dataTarget" @click="setStore(obj)">Remover</button>
                        <button v-if="removerbb && obj.status == 'criacao'"
                            class="btn btn-outline-danger btn-sm float-end" style="margin-right: 5px;"
                            :data-bs-toggle="removerbb.dataToggle" :data-bs-target="removerbb.dataTarget"
                            @click="setStore(obj)">Remover</button>
                        <button v-if="rateio" class="btn btn-outline-primary btn-sm float-end"
                            style="margin-right: 5px;" :data-bs-toggle="rateio.dataToggle"
                            :data-bs-target="rateio.dataTarget" @click="setStore(obj)">Extrato</button>
                        <button v-if="depositos" class="btn btn-outline-secondary btn-sm float-end"
                            style="margin-right: 5px;" :data-bs-toggle="depositos.dataToggle"
                            :data-bs-target="depositos.dataTarget" @click="setStore(obj)">Depósitos</button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: ['dados', 'titulos', 'editar', 'remover', 'removerbb', 'rateio', 'depositos', 'componentpai', 'pdf', 'status', 'anomes'],
    methods: {
        setStore(obj) {
            this.$store.state.transacao.status = ''
            this.$store.state.transacao.mensagem = ''
            if (this.componentpai == 'pacientes') {
                this.$store.state.item = this.dados.find(dado => dado.id === obj.id)
            } if (this.componentpai == 'landesc') {
                this.$store.state.item = this.dados.find(dado => dado.id === obj.id)
            } if (this.componentpai == 'usuarios') {
                this.$store.state.item = this.dados.find(dado => dado.email === obj.email)
            } if (this.componentpai == 'caps') {
                this.$store.state.item = this.dados.find(dado => dado.id === obj.id)
            } if (this.componentpai == 'fornecedor') {
                this.$store.state.item = this.dados.find(dado => dado.id === obj.id)
            } if (this.componentpai == 'caixa') {
                this.$store.state.item = this.dados.find(dado => dado.id === obj.id)
                this.$store.state.relatorio_id = obj.id
                this.$store.state.nome_rel_paciente = obj.nome
                this.$store.state.cod_conta_caixa = obj.conta_contabil_reduzido
                this.$store.state.nome_caps = obj.caps.nome
                this.$store.state.centro_custo_paciente = obj.centro_custo
                this.relPaciente(obj.id)
                this.saldoAtual(obj.caps.id)
            }

            function substituirNullPorZero(obj) {
                // Cria um novo objeto para evitar modificar o original
                const novoObjeto = Array.isArray(obj) ? [] : {};

                // Itera sobre cada chave do objeto
                for (let key in obj) {
                    // Se o valor é um objeto ou array, chama a função recursivamente
                    if (obj[key] !== null && typeof obj[key] === 'object') {
                        novoObjeto[key] = substituirNullPorZero(obj[key]);
                    } else {
                        // Substitui null por 0, caso contrário mantém o valor original
                        novoObjeto[key] = obj[key] === null ? '' : obj[key];
                    }
                }

                return novoObjeto;
            }
            this.$store.state.item = substituirNullPorZero(this.$store.state.item)
        },
        relPaciente(id) {
            let url = 'https://contasmoradores.candido.org.br/api/v1/caixinha?filtro=data_lancamento:like:' + this.anomes + '%;paciente_id:=:' + id
            this.$store.state.relatorio_id = id 
            let config = {
                headers: {
                    'Accept': 'application/json'
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.$store.state.item = response.data.sort((a, b) => new Date(b.data_lancamento) - new Date(a.data_lancamento))
                })
                .catch(errors => {
                })
        },
        saldoAtual(caps_id) {
            let url = 'https://contasmoradores.candido.org.br/saldo-atual/' + caps_id + '/' + this.$store.state.relatorio_id

            let config = {
                headers: {
                    'Accept': 'application/json'
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.$store.state.saldoRelAtual = response.data.saldo
                })
                .catch(errors => {
                })
        }
    },
    mounted() {
    },
    computed: {
        dadosFiltrados() {
            let campos = Object.keys(this.titulos)
            let dadosFiltrados = []

            this.dados.map((item, chave) => {
                let itemFiltrado = {}
                campos.forEach(campo => {
                    itemFiltrado[campo] = item[campo]
                })
                dadosFiltrados.push(itemFiltrado)
            })
            return dadosFiltrados
        }
    }
}
</script>
<style>
.taxa {
    width: 85px;
    height: 30px;
    background-color: transparent;
    font-size: 12px;
    border: 2px solid orange;
    align-items: center;
    justify-content: center;
    line-height: 12px;
    padding: 2px;
}

.taxa::before {
    content: "Taxa Transação";
    color: #000
}

.finalizado {
    width: 85px;
    height: 30px;
    background-color: transparent;
    font-size: 12px;
    border: 1px solid gray;
    align-items: center;
    justify-content: center;
    line-height: 12px;
    padding: 2px;
}

.finalizado::before {
    content: "Processo Finalizado";
    color: gray
}

.pago {
    width: 85px;
    height: 30px;
    background-color: transparent;
    font-size: 12px;
    border: 2px solid green;
    align-items: center;
    justify-content: center;
    line-height: 12px;
    padding: 2px;
}

.pago::before {
    content: "Pendente Comprovante";
    color: #000
}

.pendente {
    width: 85px;
    height: 30px;
    background-color: transparent;
    font-size: 12px;
    border: 2px solid red;
    align-items: center;
    justify-content: center;
    line-height: 12px;
    padding: 2px;
}

.pendente::before {
    content: "Pendente Pagamento";
    color: #000
}

.criacao {
    width: 15px;
    height: 15px;
    background-color: gray;
    clip-path: circle(50%);
}

.carimbo {
    display: inline-block;
    padding: 8px 16px;
    border: 3px solid green;
    color: green;
    font-family: 'Special Elite', monospace;
    /* Fonte que parece carimbo */
    font-size: 20px;
    text-transform: uppercase;
    border-radius: 4px;
    transform: rotate(-5deg);
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    opacity: 0.9;
    letter-spacing: 1px;
    background-color: white;
    float: right;
    font-size: 10px;
}

.carimbo::before {
    content: "Aprovado";
}
</style>